'use client'

// COMPARTIDO: barbershop + studio + admin. Renderiza el logo del tenant
// desde TenantContext. Cambios aquí afectan a los tres modos.

import { useTenant } from '@/contexts/TenantContext'
import { Scissors } from 'lucide-react'
import { getImageUrl } from '@/lib/utils'

interface TenantLogoProps {
  size?: number
  className?: string
  showName?: boolean
}

export default function TenantLogo({ size = 48, className = '', showName = false }: TenantLogoProps) {
  const { tenant, loading } = useTenant()

  const logoUrl = tenant?.logo_url ? getImageUrl(tenant.logo_url, 'thumb') : null
  const tenantName = tenant?.name || 'BARBERÍA'

  if (loading) {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <div
          className="rounded-lg bg-surface animate-pulse"
          style={{ width: size, height: size }}
        />
        {showName && (
          <div className="h-6 w-32 bg-surface rounded animate-pulse" />
        )}
      </div>
    )
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {logoUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={logoUrl}
          alt={tenantName}
          className="object-contain rounded-lg"
          style={{ width: size, height: size }}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <div 
          className="flex items-center justify-center rounded-lg bg-white"
          style={{ width: size, height: size }}
        >
          <Scissors className="text-black" style={{ width: size * 0.55, height: size * 0.55 }} />
        </div>
      )}
      {showName && (
        <span className="text-xl font-bold">{tenantName}</span>
      )}
    </div>
  )
}
